
import { Component, Vue } from 'vue-property-decorator';

import UsersTable from '@/components/tables/UsersTable.vue';
import FavUsersTable from '@/components/tables/FavUsersTable.vue';
import ApiFavUsersTable from '@/components/tables/ApiFavUsersTable.vue';

@Component({
    name: 'UserList',
    components: {
        UsersTable,
        FavUsersTable,
        ApiFavUsersTable,
    },
})
export default class UserList extends Vue {}
